import {Component, computed, effect, inject, input, model, signal} from '@angular/core';
import {Router} from '@angular/router';
import {Dialog} from 'primeng/dialog';
import {TranslocoPipe} from '@jsverse/transloco';
import {SafeHtmlComponent} from '../../../shared/components/safe-html-output/safe-html-output.component';
import {APP_ROUTES} from '../../../app.routes';
import {HrToolService} from '../hr-tool.service';
import {ExtendedHrTool, HrToolProviderGroup} from '../hr-tool.types';

@Component({
  selector: 'app-hr-tool-provider-modal',
  imports: [Dialog, TranslocoPipe, SafeHtmlComponent],
  templateUrl: './hr-tool-provider-modal.component.html',
})
export class HrToolProviderModalComponent {
  private readonly router = inject(Router);
  private readonly hrToolsService = inject(HrToolService);

  readonly group = input<HrToolProviderGroup | null>(null);
  visible = model<boolean>(false);

  private readonly logoBroken = signal(false);
  protected readonly showLogo = computed(() => !!this.group()?.logoUrl && !this.logoBroken());

  constructor() {
    effect(() => {
      this.group();
      this.logoBroken.set(false);
    });
  }

  protected onLogoError(): void {
    this.logoBroken.set(true);
  }

  protected openTool(tool: ExtendedHrTool): void {
    this.visible.set(false);
    void this.router.navigate([APP_ROUTES.HR_TOOLS, tool.id]);
  }

  protected addToCompare(tool: ExtendedHrTool): void {
    this.hrToolsService.addToolToComparison(tool);
  }
}
